/**
 * 数値を [min, max] にクランプする純粋関数群。
 * React/Pixi/Zustand に依存しないため、エンジン・ストア・UI のいずれからも参照できる。
 */

/** 整数刻みでクランプ。NaN/Infinity が入った場合は min を返す。 */
export function clampInt(v: number, min: number, max: number): number {
  if (!Number.isFinite(v)) return min;
  return Math.min(max, Math.max(min, Math.round(v)));
}

/** 連続値クランプ。NaN/Infinity が入った場合は min を返す。 */
export function clamp(v: number, min: number, max: number): number {
  if (!Number.isFinite(v)) return min;
  return Math.min(max, Math.max(min, v));
}
